
export const featuredChefs = [
  {
    id: 1,
    name: "Chef Gordon",
    specialty: "Modern South African Cuisine",
    location: "Johannesburg, Gauteng",
    rating: 4.9,
    reviews: 127,
    experience: "15+ years",
    description: "Award-winning chef specializing in contemporary South African flavors with international techniques. Private Chef Johannesburg.",
    image: "https://static.readdy.ai/image/5c2d16bce98820aab16a3b52f2f5cfd8/d6e0050374475abab55ba599156cbec8.jpeg",
    available: true,
    cuisines: ["South African", "Fine Dining", "Seafood", "Contemporary"]
  }
];
